import { action, computed, makeObservable, observable } from 'mobx';
import { nothing, Maybe } from 'maybeasy';
import {
  State,
  idle,
  loading,
  success,
  failed,
  empty,
  DashboardSummaryPayload,
  DashboardSummaryFilters,
} from './Types';

class DashboardSummaryStore {
  @observable
  _state: State = idle();

  @observable
  _hadPreviousSuccess: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @computed
  get state(): State {
    return this._state;
  }

  @computed
  get hadPreviousSuccess(): boolean {
    return this._hadPreviousSuccess;
  }

  @action
  reset = () => {
    this._state = idle();
    this._hadPreviousSuccess = false;
  };

  @action
  startLoading = (dashboardId: string, tabId: Maybe<string> = nothing()) => {
    // Can start loading from any state except when already loading
    if (this._state.kind === 'loading') return;
    this._state = loading(dashboardId, tabId);
  };

  @action
  setSuccess = (summary: DashboardSummaryPayload) => {
    // Only transition from loading state
    if (this._state.kind !== 'loading') return;
    this._hadPreviousSuccess = true;
    this._state = success(summary);
  };

  @action
  setFailed = (error: string) => {
    // Only transition from loading state
    if (this._state.kind !== 'loading') return;
    this._state = failed(error, this._state.dashboardId, this._state.tabId);
  };

  @action
  setEmpty = (message: string, filters: DashboardSummaryFilters) => {
    // Only transition from loading state
    if (this._state.kind !== 'loading') return;
    this._state = empty(message, filters, this._hadPreviousSuccess);
  };
}

export default DashboardSummaryStore;
